import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/articles';

export default function ArticleCards() {
  const displayedArticles = seoArticles.slice(1);

  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-100">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs font-medium text-secondary-500 tracking-widest uppercase mb-3">Shopping Knowledge</p>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900">
            GTBuy Sheet Guides & Articles
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            Level up your shopping game with our collection of in-depth guides, tips, and strategies
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {displayedArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-background-50 rounded-xl overflow-hidden hover:ring-2 hover:ring-primary-300 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-full">
                    {article.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="mt-auto pt-4 flex items-center gap-1.5 text-xs font-medium text-accent-600">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/gtbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Read the Complete Guide
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}